import { Typography } from '@mui/material';
import React from 'react';

import env from '../../env';
import useAccess from '../../utils/useAccess';
import usePermissions from '../../utils/usePermissions';
import ExternalLink from '../ExternalLink';

export default function IssueLink({ allowExternal, children, domId, issue, ...props }) {
    const { canViewTickets } = usePermissions({ canViewTickets: 'issue_read' });
    const { isCleveron } = useAccess();

    if (!issue?.id) {
        return <Typography variant="body2">—</Typography>;
    }

    const { accessible, id, jiraIssueKey } = issue;
    let value;

    if (jiraIssueKey) {
        if (isCleveron && allowExternal) {
            value = (
                <ExternalLink
                    id={`${domId}Link`}
                    url={`${env.REACT_APP_JIRA_ISSUE_URL}${jiraIssueKey}`}
                    {...props}
                >
                    {children ?? jiraIssueKey}
                </ExternalLink>
            );
        } else if (canViewTickets && accessible) {
            value = (
                <ExternalLink id={`${domId}Link`} url={`/tickets/tickets/${id}`} {...props}>
                    {children ?? jiraIssueKey}
                </ExternalLink>
            );
        } else {
            value = <Typography variant="body2">{children ?? jiraIssueKey}</Typography>;
        }
    } else if (canViewTickets && accessible) {
        value = (
            <ExternalLink id={`${domId}Link`} url={`/tickets/tickets/${id}`} {...props}>
                {children ?? `UNSYNCED-${id}`}
            </ExternalLink>
        );
    } else {
        value = <Typography variant="body2">{children ?? `UNSYNCED-${id}`}</Typography>;
    }

    return value;
}
